import Text from 'components/Text/Text';
import { IModifiersForModifierGroupsInfo } from 'types';
import React, { useMemo } from 'react';
import style from './ModifiersList.module.scss';

interface IModifiersList {
	modifiersOfModifierGroups: IModifiersForModifierGroupsInfo[];
}

const ModifiersList: React.FC<IModifiersList> = ({ modifiersOfModifierGroups }) => {
	const modifiersList = useMemo(() => {
		return modifiersOfModifierGroups.map((el) => (
			<div className={style.item} key={el.modifierId}>
				<div className={style.dot} />
				<Text translationKey={el.modifierName} withTooltip={true} />
			</div>
		));
	}, [modifiersOfModifierGroups]);

	return (
		<div data-test="ModifiersList">
			<Text translationNameSpace="form" translationKey="modifiersLabel" theme="neutralLight" size="xs" />
			<div className={style.listOfItems}>{modifiersOfModifierGroups.length ? modifiersList : '-'}</div>
		</div>
	);
};

export default React.memo(ModifiersList);
